import { SaveAssignmentPresetPayload } from './assignmentPresets.types';
import { AssignmentPresetType } from '../login/login.types';

export const types = {
    CREATE_PRESET: 'CREATE_PRESET',
    UPDATE_PRESET: 'UPDATE_PRESET',
    DELETE_PRESET: 'DELETE_PRESET',
    SAVE_PRESET_DONE: 'SAVE_PRESET_DONE',
    SAVE_PRESET_CONFLICT: 'SAVE_PRESET_CONFLICT',
    SAVE_PRESET_ERROR: 'SAVE_PRESET_ERROR',
    RESET_PRESET_STATUS: 'RESET_PRESET_STATUS',
    FETCH_PRESETS: 'FETCH_PRESETS',
    PRESETS_RECEIVED: 'PRESETS_RECEIVED',
};

const createPreset = (accountId: string, payload: SaveAssignmentPresetPayload) => ({ type: types.CREATE_PRESET, accountId, payload });
const updatePreset = (accountId: string, id: string, payload: SaveAssignmentPresetPayload) => ({ type: types.UPDATE_PRESET, accountId, id, payload });
const deletePreset = (accountId: string, id: string) => ({ type: types.DELETE_PRESET, accountId, id });
const savePresetDone = (id?: string) => ({ type: types.SAVE_PRESET_DONE, id });
const savePresetConflict = () => ({ type: types.SAVE_PRESET_CONFLICT });
const savePresetError = () => ({ type: types.SAVE_PRESET_ERROR });
const resetStatus = () => ({ type: types.RESET_PRESET_STATUS });
const fetchPresets = (accountId: string) => ({ type: types.FETCH_PRESETS, accountId });
const presetsReceived = (accountId: string, presets: AssignmentPresetType[]) => ({ type: types.PRESETS_RECEIVED, accountId, presets });

export default { createPreset, updatePreset, deletePreset, savePresetDone, savePresetConflict, savePresetError, resetStatus, fetchPresets, presetsReceived };
